var CmsButtonComponent = /** @class */ (function () {
    function CmsButtonComponent(id, cb) {
        var _this = this;
        this.unmount = function () {
            _this.component.removeEventListener('click', function () { return _this.clickCallback(); });
        };
        var elem = document.querySelector("#".concat(id));
        if (!elem) {
            throw new Error("Element id [".concat(id, "] was not found in DOM"));
        }
        this.clickCallback = cb;
        this.component = elem;
        this.component.addEventListener('click', function () { return _this.clickCallback(); });
    }
    return CmsButtonComponent;
}());
export default CmsButtonComponent;
